// Browser-safe Firebase Web SDK bootstrap.
//
// Reads only GATSBY_FIREBASE_* values, which are public client identifiers
// (not secrets) and are already exposed to the browser bundle by Gatsby's
// build process. Never add non-GATSBY_-prefixed or server-only values here.
//
// Not currently imported by the Gatsby public site or by gatsby-node.js.
// This module exists so the future admin application has a ready client
// bootstrap to import.

const { initializeApp, getApps, getApp } = require("firebase/app")

const firebaseConfig = {
  apiKey: process.env.GATSBY_FIREBASE_API_KEY,
  authDomain: process.env.GATSBY_FIREBASE_AUTH_DOMAIN,
  databaseURL: process.env.GATSBY_FIREBASE_DATABASE_URL,
  projectId: process.env.GATSBY_FIREBASE_PROJECT_ID,
  storageBucket: process.env.GATSBY_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.GATSBY_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.GATSBY_FIREBASE_APP_ID,
  measurementId: process.env.GATSBY_FIREBASE_MEASUREMENT_ID,
}

function getFirebaseClientApp() {
  return getApps().length ? getApp() : initializeApp(firebaseConfig)
}

module.exports = { getFirebaseClientApp, firebaseConfig }
